import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { Text } from '@naf/text';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing.space20};
`;

export const StruckText = styled(Text)`
  margin-left: ${spacing.space20};
  text-decoration: line-through;
`;

export const WindshieldWiperChange = styled.div`
  margin-bottom: ${spacing.space12};

  @media (max-width: ${breakpoints.s}) {
    margin-bottom: 0;
  }

  h2 {
    margin: 0 0 ${spacing.space8} !important;
  }
  p {
    margin: 0 !important;
  }
`;

export const SuccessText = styled(Text)`
  display: inline-flex;
  color: ${nafColor.information.successDark};
  margin-left: ${spacing.space8} !important;
`;

export const Search = styled.div`
  display: flex;
  margin-top: ${spacing.space32};

  button {
    margin-left: ${spacing.space16};
  }

  @media (max-width: ${breakpoints.m}) {
    margin-top: ${spacing.space20};
  }

  @media (max-width: ${breakpoints.s}) {
    margin-top: ${spacing.space16};
    button {
      margin-left: ${spacing.space8};
    }
    > div {
      flex-grow: 1;
    }
  }
`;

export const LookupResultSuccess = styled.div`
  margin-top: ${spacing.space8};

  svg {
    color: ${nafColor.information.successDark};
  }
  a {
    margin-top: ${spacing.space16};
  }
`;

export const LookupResultError = styled.div`
  margin-top: ${spacing.space40};

  h3 {
    margin: 0 0 ${spacing.space8};
  }
  p {
    margin: 0;
  }
  a {
    margin-top: ${spacing.space16};
  }

  @media (max-width: ${breakpoints.s}) {
    margin-top: ${spacing.space32};
  }
`;

export const VehicleText = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${spacing.space20};

  > *:first-child {
    margin-right: ${spacing.space4};
  }
`;

export const Summary = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${spacing.space24} 0;
  max-width: 512px;

  h3 {
    margin: 0 0 ${spacing.space8};
  }

  h4,
  p {
    margin: 0;
  }

  @media (max-width: ${breakpoints.s}) {
    margin: ${spacing.space20} 0;
    max-width: 100%;
  }
`;

export const SpinnerWrapper = styled.div`
  margin-top: ${spacing.space24};
  width: fit-content;

  @media (max-width: ${breakpoints.s}) {
    margin-left: auto;
    margin-right: auto;
  }
`;
